module.exports = __webpack_public_path__ + "static/media/policy-focused.ab50318b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/policy-focused.svg
// module id = 1230
// module chunks = 0